const firebaseConfig = {
    apiKey: "AIzaSyDIy3-8Vwj9zpcAsP1LERtdRjPAPATaQuE",
    authDomain: "larus-certificates.firebaseapp.com",
    databaseURL: "https://larus-certificates-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "larus-certificates",
    storageBucket: "larus-certificates.appspot.com",
    messagingSenderId: "434820224591",
    appId: "1:434820224591:web:92420071755f3f37d13c3a"
};

export default firebaseConfig;